import * as React from 'react';
import * as styles from './styles.scss';
import { observer } from 'mobx-react-lite';
import { CompleteCheckbox } from 'owa-todo-views';
import type { TaskViewCompletionProps } from '../schema';
import useTaskViewCompletionState from '../hooks/useTaskViewCompletionState';

export default observer(function TaskViewCompletion(props: TaskViewCompletionProps) {
    const { isComplete, onToggleComplete } = useTaskViewCompletionState(props);
    return (
        <CompleteCheckbox
            isComplete={isComplete}
            onToggleComplete={onToggleComplete}
            checkboxRootClassName={styles.checkboxRoot}
            checkboxClassName={isComplete ? styles.checkbox : undefined}
        />
    );
});
